"use client"

import { ChevronDown } from "lucide-react";
import { PathnameDetailType } from "@/app/types";
import { Accordion, AccordionDetails, AccordionSummary, Box, colors, Grid2 as Grid, Typography, useTheme } from "@mui/material";
import { Fragment } from "react";
import PlpSectionHeading from "./PlpSectionHeading";

export default function PlpFaq({
    items
}: {
    items?: PathnameDetailType['eq_path']['faq']
}) {
    const theme = useTheme()
    const leftColumn = items?.filter((_, i) => i % 2 === 0);
    const rightColumn = items?.filter((_, i) => i % 2 === 1);
    if (!items || !items.length) return <Fragment />
    return (
        <Box component="section" sx={{
            bgcolor: '#fff',
            width: 1

        }}>
            <Box sx={{
                maxWidth: 1400,
                marginX: 'auto',
                py: 4,
                [theme.breakpoints.down('lg2')]: {
                    px: 3
                },
            }}>
                <PlpSectionHeading>سوالات متداول</PlpSectionHeading>
                <Grid container spacing={{ xs: 0, md: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }} sx={{
                    }}>
                        {leftColumn.map(faq => (
                            <AccordionItem faq={faq} key={faq.id} />
                        ))}
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        {rightColumn.map(faq => (
                            <AccordionItem faq={faq} key={faq.id} />
                        ))}
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}

const AccordionItem = ({ faq }: {
    faq: PathnameDetailType['eq_path']['faq'][0]
}) => {
    const theme = useTheme()
    const answer = faq.answer.replace(
        /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
        '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    return (
        <Accordion elevation={0} sx={{
            bgcolor: 'transparent',
            '&::before': {
                opacity: '0 !important',
                height: 0,
            },
            margin: '0 !important',
            mb: 1,
            borderTop: '1px solid',
            borderColor: colors.grey[400],
            borderRadius: '0 !important',
            // '&:first-of-type': {
            //     border: 'unset'
            // },
        }}>
            <AccordionSummary expandIcon={<ChevronDown color={colors.grey[700]} />} sx={{
                borderRadius: 0,
                [theme.breakpoints.down('md')]: {
                    padding: 0
                },
            }}>
                <Typography sx={{
                    fontWeight: 500,
                    color: colors.grey[900],
                    fontSize: 16,
                    [theme.breakpoints.down('md')]: {
                        fontSize: 13
                    },
                }}>{faq.question}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{
                [theme.breakpoints.down('md')]: {
                    padding: 0
                },
            }}>
                <Typography sx={{
                    fontSize: 14,
                    color: colors.grey[800],
                    textAlign: 'justify',
                    lineHeight: '28px',
                    whiteSpace: 'pre-line',
                    pb: 1,
                    '& a': {
                        color: colors.red[900],
                        textDecoration: 'underline',
                        fontWeight: 500,
                        '&:hover': {
                            textDecoration: 'underline'
                        }
                    },
                    [theme.breakpoints.down('md')]: {
                        fontSize: 12,
                        lineHeight: '23px'
                    },
                }} dangerouslySetInnerHTML={{ __html: answer }} />
            </AccordionDetails>
        </Accordion>
    )
}